'use strict';

bbw.shared.PageCtrl = ngtk.controller.Base.extend({

    $inject: ['$scope', 'bbw.RedirectSvc', '$attrs', '$rootScope'],

    _init: function() {
        var parentLink = this.$attrs.parentLink;
        if (parentLink) {
            this.$rootScope.$broadcast(bbw.globalEvent.mobileBackShow);
            bbw.onMobileBack(this.$scope, function() {
                this._bbwRedirectSvc.redirect({url: parentLink, xhr: true});
            }.bind(this));
        }
    }

});
